export default "__VITE_ASSET__B1_9ALvT__"